var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoResults = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 366.283,
    height: 287.449,
    viewBox: "0 0 366.283 287.449",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.031,
    y1: 0.24,
    x2: 1.042,
    y2: 0.843,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009fe3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.07,
    y1: -0.052,
    x2: 1.209,
    y2: 1.072,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0079ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009fe3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_18718",
    "data-name": "Groupe 18718",
    transform: "translate(-66.131 -73.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND",
    transform: "translate(78.222 73.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15132",
    "data-name": "Groupe 15132",
    transform: "translate(5.162 4.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15131",
    "data-name": "Groupe 15131",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15126",
    "data-name": "Groupe 15126",
    transform: "translate(11.036 17.866)",
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15125",
    "data-name": "Groupe 15125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15124",
    "data-name": "Groupe 15124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_531",
    "data-name": "Trac\\xE9 531",
    d: "M325.78,213.391a83.836,83.836,0,0,0-.385-14.293c-2.523-22.271-13.95-43.274-30.766-58.092-6-5.286-12.827-10.023-16.731-17-6.576-11.751-6.077-25.258-14.239-36.862a69.03,69.03,0,0,0-33.5-25.329c-40.035-13.872-96.086,8.715-91.04,56.951.018.173.038.425.059.743a17.558,17.558,0,0,1-17.2,18.681c-36.938.877-68.734,29.356-75.537,65.431-4.375,23.2,2.79,48.629,19.76,65.041,12.668,12.251,29.665,18.981,46.67,23.606,34.1,9.272,69.976,11.216,105.131,7.67,32.908-3.318,67.62-12.779,88.9-38.1A83.139,83.139,0,0,0,325.78,213.391Z",
    transform: "translate(-45.178 -57.778)",
    fill: "#e1e2fe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15127",
    "data-name": "Groupe 15127",
    transform: "translate(112.598)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    cx: 8.594,
    cy: 8.594,
    r: 8.594,
    transform: "translate(0 16.968) rotate(-80.821)",
    fill: "#e1e2fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15128",
    "data-name": "Groupe 15128",
    transform: "translate(234.145 0.18)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 4.434,
    cy: 4.434,
    r: 4.434,
    fill: "#e1e2fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15129",
    "data-name": "Groupe 15129",
    transform: "translate(74.844 21.891)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    cx: 5.942,
    cy: 5.942,
    r: 5.942,
    transform: "translate(0 11.531) rotate(-75.998)",
    fill: "#e1e2fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15130",
    "data-name": "Groupe 15130",
    transform: "translate(0 231.064)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 13.529,
    cy: 13.529,
    r: 13.529,
    fill: "#e1e2fe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15136",
    "data-name": "Groupe 15136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15133",
    "data-name": "Groupe 15133",
    transform: "translate(11.331)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_532",
    "data-name": "Trac\\xE9 532",
    d: "M455.361,69.359a15.291,15.291,0,0,0-6.62-20.586c-7.513-3.857-21.949-3.573-25.806,3.94s7.706,13.96,12.42,20.966C441.931,83.449,451.5,76.871,455.361,69.359Z",
    transform: "translate(-173.574 -30.941)",
    fill: "#80bbdc",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_533",
    "data-name": "Trac\\xE9 533",
    d: "M419.339,425.811a11.715,11.715,0,0,0,16.2-3.488c3.509-5.436,4.385-16.463-1.05-19.972s-11.226,4.818-16.924,7.882C409.613,414.506,413.9,422.3,419.339,425.811Z",
    transform: "translate(-170.402 -156.494)",
    fill: "#80bbdc",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_534",
    "data-name": "Trac\\xE9 534",
    d: "M64.729,26.475a14.773,14.773,0,0,0-20.878.772c-5.552,5.979-9.064,19.48-3.085,25.033s15-3.516,22.748-6.068C74.323,42.651,70.708,32.027,64.729,26.475Z",
    transform: "translate(-37.65 -22.527)",
    fill: "#80bbdc",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15135",
    "data-name": "Groupe 15135",
    transform: "translate(0 22.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_535",
    "data-name": "Trac\\xE9 535",
    d: "M25.578,103.175a60.92,60.92,0,0,0-4.228,37.382c3.007,14.661,12.134,25.925,8.967,41.566-1.929,9.527-2.412,18.353-3.39,27.779-2.009,19.357,10.559,36.412,26.15,45.622C65.739,263,80.585,265.81,95.144,265.61c13.1-.18,26.183-2.6,38.88-5.853,12.236-3.135,24.2-7.267,37.026-5.963,10.667,1.084,20.274,5.7,30.208,9.134,23.717,8.209,52.447,9.368,74.134-3.13a62.568,62.568,0,0,0,29.285-68.136c-2.657-11.732-7.144-23.559-5.751-35.783.971-8.518,4.867-16.74,4.153-25.283-.474-5.676-2.974-11-6.03-15.81-11.16-17.552-29.846-29.3-49.613-35.778-18.6-6.093-37.785-10.506-57.152-9.04-40.042,3.031-48.2-3.329-89.126-12.081C74.741,52.236,45.19,72.378,29.731,95.712A55.723,55.723,0,0,0,25.578,103.175Z",
    transform: "translate(-20.124 -56.926)",
    fill: "#80bbdc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15134",
    "data-name": "Groupe 15134",
    transform: "translate(13.044 11.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_536",
    "data-name": "Trac\\xE9 536",
    d: "M60.259,127.716c-.821,9.24,2.3,18.762-.31,27.912-3.119,10.956-12.146,19.161-15.826,29.917a69.262,69.262,0,0,0,1.427,49.19c3.182,7.464,7.831,14.4,14.18,19.2,9.787,7.395,22.611,9.017,34.672,8.079,17.95-1.4,36.889-9.166,54.937-7.048,9.959,1.17,13,11.949,18.143,19.058a59.6,59.6,0,0,0,22.5,18.562,63.791,63.791,0,0,0,51.979,1.455c17.6-7.5,32.944-25.8,31.936-46.508-.466-9.578-4.3-19.091-2.526-28.5,2.228-11.811,11.128-22.574,17.576-32.2A74.249,74.249,0,0,0,301.224,150.6c.009-.147.019-.293.027-.44a49.34,49.34,0,0,0-33.974-49.631L222.112,85.675C176.284,70.6,130.5,71.1,88.358,93.221,79.24,98.008,64.393,112.269,61.335,122.1A26.8,26.8,0,0,0,60.259,127.716Z",
    transform: "translate(-40.299 -75.338)",
    fill: "#80bbdc",
    opacity: 0.6
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 2.909,
    cy: 2.909,
    r: 2.909,
    transform: "translate(286.419 229.219)",
    fill: "#80bbdc",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 2.909,
    cy: 2.909,
    r: 2.909,
    transform: "translate(152.026 2.479)",
    fill: "#80bbdc",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 2.909,
    cy: 2.909,
    r: 2.909,
    transform: "translate(46.926 256.048)",
    fill: "#3e479b",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 2.263,
    cy: 2.263,
    r: 2.263,
    transform: "translate(231.199 268.928)",
    fill: "#8b2885",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 0.97,
    cy: 0.97,
    r: 0.97,
    transform: "translate(36.022 53.965)",
    fill: "#80bbdc",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_537",
    "data-name": "Trac\\xE9 537",
    d: "M393.084,60.446A3.494,3.494,0,1,1,390.4,56.3,3.494,3.494,0,0,1,393.084,60.446Z",
    transform: "translate(-149.521 -34.438)",
    fill: "#8b2885",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_538",
    "data-name": "Trac\\xE9 538",
    d: "M106.59,37.017a1.37,1.37,0,1,1-1.053-1.626A1.369,1.369,0,0,1,106.59,37.017Z",
    transform: "translate(-49.731 -27.064)",
    fill: "#8b2885",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_539",
    "data-name": "Trac\\xE9 539",
    d: "M444.571,28.25a1.165,1.165,0,1,1-.9-1.382A1.164,1.164,0,0,1,444.571,28.25Z",
    transform: "translate(-169.35 -24.053)",
    fill: "#80bbdc",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_540",
    "data-name": "Trac\\xE9 540",
    d: "M63.518,457.875a1.165,1.165,0,1,1-.9-1.382A1.164,1.164,0,0,1,63.518,457.875Z",
    transform: "translate(-34.649 -175.924)",
    fill: "#3e479b",
    opacity: 0.58
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    transform: "translate(66.131 93.984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15165",
    "data-name": "Groupe 15165",
    transform: "translate(53.833 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15155",
    "data-name": "Groupe 15155",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24797",
    "data-name": "Rectangle 24797",
    width: 182.538,
    height: 135.078,
    rx: 1.851,
    transform: "translate(2.933 163.176) rotate(-59.337)",
    fill: "#3e479b",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24798",
    "data-name": "Rectangle 24798",
    width: 182.538,
    height: 135.078,
    rx: 1.851,
    transform: "translate(0 157.016) rotate(-59.337)",
    fill: "#8e71b2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15158",
    "data-name": "Groupe 15158",
    transform: "translate(13.26 11.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_562",
    "data-name": "Trac\\xE9 562",
    d: "M392.608,385.351,263.525,361.557a1.91,1.91,0,0,1-1.532-2.226l32.4-175.756a1.91,1.91,0,0,1,2.225-1.532L425.7,205.837a1.91,1.91,0,0,1,1.532,2.225l-32.4,175.757A1.909,1.909,0,0,1,392.608,385.351Z",
    transform: "translate(-258.887 -173.844)",
    fill: "#3e479b",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24799",
    "data-name": "Rectangle 24799",
    width: 182.538,
    height: 135.078,
    transform: "matrix(0.181, -0.983, 0.983, 0.181, 0, 182.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_611",
    "data-name": "Trac\\xE9 611",
    d: "M2.792,0H179.746a2.792,2.792,0,0,1,2.792,2.792V132.286a2.792,2.792,0,0,1-2.792,2.792H2.792A2.792,2.792,0,0,1,0,132.286V2.792A2.792,2.792,0,0,1,2.792,0Z",
    transform: "translate(0 182.423) rotate(-79.556)",
    fill: "#b3a0cb",
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_563",
    "data-name": "Trac\\xE9 563",
    d: "M401.337,221.387a1.07,1.07,0,0,1-.189-.017l-32.312-5.956a1.032,1.032,0,0,1,.375-2.03l32.312,5.956a1.032,1.032,0,0,1-.186,2.046Z",
    transform: "translate(-255.509 -172.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_564",
    "data-name": "Trac\\xE9 564",
    d: "M399.493,231.391a1.082,1.082,0,0,1-.189-.018l-32.312-5.956a1.032,1.032,0,1,1,.375-2.03l32.313,5.956a1.032,1.032,0,0,1-.187,2.047Z",
    transform: "translate(-255.568 -172.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_565",
    "data-name": "Trac\\xE9 565",
    d: "M397.489,242.264a1.086,1.086,0,0,1-.189-.018l-32.312-5.956a1.032,1.032,0,0,1,.375-2.03l32.313,5.956a1.032,1.032,0,0,1-.187,2.047Z",
    transform: "translate(-255.632 -172.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15156",
    "data-name": "Groupe 15156",
    transform: "translate(34.469)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24801",
    "data-name": "Rectangle 24801",
    width: 64.678,
    height: 60.431,
    rx: 2.004,
    transform: "translate(0 69.044) rotate(-79.556)",
    fill: "#3e479b",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24802",
    "data-name": "Rectangle 24802",
    width: 61.455,
    height: 57.804,
    rx: 2.004,
    transform: "translate(0.549 66.064) rotate(-79.556)",
    fill: "#0078b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_566",
    "data-name": "Trac\\xE9 566",
    d: "M359.248,197.371,302.4,186.893l.992-5.379a2.008,2.008,0,0,1,2.338-1.611l52.969,9.765a1.933,1.933,0,0,1,1.552,2.254Z",
    transform: "translate(-292.068 -173.912)",
    fill: "#ecf1f7",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_567",
    "data-name": "Trac\\xE9 567",
    d: "M318.072,215.112a6.661,6.661,0,0,1-1.212-.111l-.787-.144a7.718,7.718,0,0,1-6.183-8.978l1.985-10.771a1.548,1.548,0,0,1,3.045.561l-1.985,10.771a4.618,4.618,0,0,0,3.7,5.373l.787.144a3.585,3.585,0,0,0,4.174-2.877l5.027-27.264a3.706,3.706,0,0,0-2.968-4.31l-1.347-.248a3.932,3.932,0,0,0-4.577,3.151l-.123.673a1.548,1.548,0,0,1-3.045-.56l.124-.673a7.034,7.034,0,0,1,8.182-5.635l1.347.248a6.806,6.806,0,0,1,5.452,7.915l-5.026,27.264A6.7,6.7,0,0,1,318.072,215.112Z",
    transform: "translate(-291.833 -174.096)",
    fill: "#40c2f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_568",
    "data-name": "Trac\\xE9 568",
    d: "M323.675,191.807a.486.486,0,0,1-.094-.008L302.954,188a.516.516,0,1,1,.188-1.014l20.626,3.8a.515.515,0,0,1-.093,1.023Z",
    transform: "translate(-292.064 -173.686)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15157",
    "data-name": "Groupe 15157",
    transform: "translate(22.325 88.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_569",
    "data-name": "Trac\\xE9 569",
    d: "M387.225,295.621a1.066,1.066,0,0,1-.188-.017L288.3,277.4a1.032,1.032,0,0,1,.376-2.03l98.732,18.2a1.032,1.032,0,0,1-.187,2.046Z",
    transform: "translate(-280.4 -259.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_570",
    "data-name": "Trac\\xE9 570",
    d: "M380.385,332.735a.984.984,0,0,1-.189-.018l-98.734-18.2a1.032,1.032,0,0,1,.376-2.03l98.733,18.2a1.032,1.032,0,0,1-.186,2.047Z",
    transform: "translate(-280.618 -258.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_571",
    "data-name": "Trac\\xE9 571",
    d: "M331.745,304.581a.972.972,0,0,1-.188-.018l-46.674-8.6a1.032,1.032,0,0,1,.376-2.029l46.673,8.6a1.032,1.032,0,0,1-.187,2.046Z",
    transform: "translate(-280.509 -259.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_572",
    "data-name": "Trac\\xE9 572",
    d: "M337.978,270.771a1,1,0,0,1-.189-.018l-46.673-8.6a1.031,1.031,0,1,1,.375-2.029l46.673,8.6a1.032,1.032,0,0,1-.186,2.047Z",
    transform: "translate(-280.311 -260.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_573",
    "data-name": "Trac\\xE9 573",
    d: "M382.156,313.724a1.073,1.073,0,0,1-.189-.017l-44.469-8.2a1.031,1.031,0,1,1,.375-2.029l44.47,8.2a1.032,1.032,0,0,1-.187,2.046Z",
    transform: "translate(-278.833 -258.722)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15181",
    "data-name": "Groupe 15181",
    transform: "translate(146.954 4.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15177",
    "data-name": "Groupe 15177",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15170",
    "data-name": "Groupe 15170",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 65.309,
    cy: 65.309,
    r: 65.309,
    transform: "translate(0 92.36) rotate(-45)",
    fill: "#fff",
    opacity: 0.21
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15171",
    "data-name": "Groupe 15171",
    transform: "translate(37.055 33.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_594",
    "data-name": "Trac\\xE9 594",
    d: "M276.626,224.915a4.128,4.128,0,0,1-4.127-4.127,59.817,59.817,0,0,1,59.749-59.749,4.127,4.127,0,0,1,0,8.255,51.553,51.553,0,0,0-51.494,51.494A4.128,4.128,0,0,1,276.626,224.915Z",
    transform: "translate(-272.499 -161.039)",
    fill: "#fff",
    opacity: 0.76
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_595",
    "data-name": "Trac\\xE9 595",
    d: "M328.177,287.848a67.372,67.372,0,1,1,67.372-67.372A67.449,67.449,0,0,1,328.177,287.848Zm0-130.617a63.245,63.245,0,1,0,63.245,63.245A63.316,63.316,0,0,0,328.177,157.23Z",
    transform: "translate(-235.817 -128.115)",
    fill: "#0078b9",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15176",
    "data-name": "Groupe 15176",
    transform: "translate(15.116 15.116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15173",
    "data-name": "Groupe 15173"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 65.309,
    cy: 65.309,
    r: 65.309,
    transform: "translate(11.935 11.935)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15172",
    "data-name": "Groupe 15172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_596",
    "data-name": "Trac\\xE9 596",
    d: "M388.478,267.541a2.735,2.735,0,0,1,.31-.253,76.389,76.389,0,1,0-13.966,13.91l8.816-8.817ZM328.45,286.057a65.309,65.309,0,1,1,65.309-65.309A65.308,65.308,0,0,1,328.45,286.057Z",
    transform: "translate(-251.206 -143.504)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_597",
    "data-name": "Trac\\xE9 597",
    d: "M328.482,298.023a77.244,77.244,0,1,1,77.243-77.243,76.5,76.5,0,0,1-16.09,47.171l-.193.192a1.83,1.83,0,0,0-.2.158l-13.76,13.747A76.5,76.5,0,0,1,328.482,298.023Zm0-152.424a75.18,75.18,0,1,0,0,150.36,74.452,74.452,0,0,0,45.689-15.507l13.609-13.609a3.167,3.167,0,0,1,.307-.263,74.451,74.451,0,0,0,15.575-45.8A75.266,75.266,0,0,0,328.482,145.6Zm0,141.521a66.341,66.341,0,1,1,66.34-66.341A66.415,66.415,0,0,1,328.482,287.121Zm0-130.617a64.277,64.277,0,1,0,64.277,64.277A64.349,64.349,0,0,0,328.482,156.5Z",
    transform: "translate(-251.238 -143.536)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_598",
    "data-name": "Trac\\xE9 598",
    d: "M382.839,275.51l-2.956-2.955a2.916,2.916,0,0,1,0-4.121l-8.816,8.817-.143.143a2.913,2.913,0,0,0,0,4.12l3.587,3.588C375.694,283.118,379.155,279.236,382.839,275.51Z",
    transform: "translate(-247.452 -139.556)",
    fill: "#0078b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_599",
    "data-name": "Trac\\xE9 599",
    d: "M379.606,268.609a2.916,2.916,0,0,0,0,4.121l2.956,2.955A81.5,81.5,0,0,1,392,267.2l-3.435-3.435a2.9,2.9,0,0,0-3.811-.253,2.752,2.752,0,0,0-.31.253Z",
    transform: "translate(-247.175 -139.732)",
    fill: "#4c65ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_600",
    "data-name": "Trac\\xE9 600",
    d: "M379.606,268.609a2.916,2.916,0,0,0,0,4.121l2.956,2.955A81.5,81.5,0,0,1,392,267.2l-3.435-3.435a2.9,2.9,0,0,0-3.811-.253,2.752,2.752,0,0,0-.31.253Z",
    transform: "translate(-247.175 -139.732)",
    fill: "#0078b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_601",
    "data-name": "Trac\\xE9 601",
    d: "M447.448,320.71,393.78,266.457c-.193-.2-.781.064-1.625.637a81.494,81.494,0,0,0-9.439,8.481c-3.685,3.726-7.146,7.609-8.329,9.592-.385.645-.533,1.093-.365,1.264l53.669,54.253a13.865,13.865,0,0,0,19.758,0A14.232,14.232,0,0,0,447.448,320.71Z",
    transform: "translate(-247.328 -139.622)",
    fill: "#409acb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15175",
    "data-name": "Groupe 15175",
    transform: "translate(134.142 126.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15174",
    "data-name": "Groupe 15174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_602",
    "data-name": "Trac\\xE9 602",
    d: "M447.216,320.71l-53.668-54.253c-.722-.731-6.838,4.749-12.089,10.163-4.468,4.605,60.3,69.58,65.758,64.064h0A14.232,14.232,0,0,0,447.216,320.71Z",
    transform: "translate(-381.238 -266.391)",
    fill: "#409acb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15182",
    "data-name": "Groupe 15182",
    transform: "translate(0 129.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_606",
    "data-name": "Trac\\xE9 606",
    d: "M260.554,292.036h-87.81a11.127,11.127,0,0,1-11.128-11.128v-7.3a11.168,11.168,0,0,0-11.168-11.168H109.89a11.168,11.168,0,0,0-11.168,11.168V389.523a10.4,10.4,0,0,0,10.4,10.4H260.554a10.4,10.4,0,0,0,10.4-10.4V302.438A10.4,10.4,0,0,0,260.554,292.036Z",
    transform: "translate(-89.045 -262.443)",
    fill: "#409acb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_607",
    "data-name": "Trac\\xE9 607",
    d: "M251.177,292.036h-87.81a11.127,11.127,0,0,1-11.128-11.128v-7.3a11.168,11.168,0,0,0-11.168-11.168H100.512a11.168,11.168,0,0,0-11.168,11.168V389.523a10.4,10.4,0,0,0,10.4,10.4H251.177a10.4,10.4,0,0,0,10.4-10.4V302.438A10.4,10.4,0,0,0,251.177,292.036Z",
    transform: "translate(-89.344 -262.443)",
    fill: "#f28393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_608",
    "data-name": "Trac\\xE9 608",
    d: "M251.177,292.036h-87.81a11.127,11.127,0,0,1-11.128-11.128v-7.3a11.168,11.168,0,0,0-11.168-11.168H100.512a11.168,11.168,0,0,0-11.168,11.168V389.523a10.4,10.4,0,0,0,10.4,10.4H251.177a10.4,10.4,0,0,0,10.4-10.4V302.438A10.4,10.4,0,0,0,251.177,292.036Z",
    transform: "translate(-89.344 -262.443)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_609",
    "data-name": "Trac\\xE9 609",
    d: "M228.9,292.036H153.179c-5.3,0-9.6-4.982-9.6-11.128v-7.3c0-6.167-4.311-11.168-9.63-11.168H98.975c-5.319,0-9.631,5-9.631,11.168V389.523c0,5.744,4.016,10.4,8.971,10.4H228.9c4.954,0,8.971-4.657,8.971-10.4V302.438C237.876,296.693,233.858,292.036,228.9,292.036Z",
    transform: "translate(-89.344 -262.443)",
    opacity: 0,
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_610",
    "data-name": "Trac\\xE9 610",
    d: "M97.239,303.387a1.032,1.032,0,0,1-1.032-1.032V277.035a7.12,7.12,0,0,1,7.113-7.113h29.887a1.032,1.032,0,0,1,0,2.064l-25.514,3.8c-2.784,0-5.557,1.276-5.557,4.061l-3.865,22.508A1.032,1.032,0,0,1,97.239,303.387Z",
    transform: "translate(-89.125 -262.205)",
    fill: "#fff"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoResults);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-results.cbb2615b3f49419d3f9c3b07ac33a0af.svg";